import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=f049de78&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports